/**
 * figureFaces — 그림 창이 `action` 에 따라 **어떤 얼굴로 뜨는가**.
 *
 * 왜 함수로 뽑았나 (2026-08-31):
 * 이 규칙이 컴포넌트 안에 여섯 자리로 흩어져 있었고, 그중 둘이 어긋나 **저장이 영영 잠기는 버그**가
 * 났다 — [그림 교체] 창에서 지난 버전을 가져오면 저장 버튼은 나오는데(`loadedVer != null`)
 * 미리보기 렌더는 안 돌아(`action === 'edit'`) `preview.ok` 가 오지 않았고, 저장 잠금은 그 값을 본다.
 * 화면은 「미리보기가 통과해야 저장할 수 있습니다」라고, 사람이 할 수 있는 일이 없는 말을 했다.
 * (오너 보고 「그림 교체 모달에서는 그림을 선택하여 저장할 수 있는 기능이 없음」)
 *
 * 규칙을 한자리에 모으면 **어긋남을 시험으로 잡을 수 있다** — figureFaces.test.js 의 첫 검사가
 * 「그리는 얼굴과 저장하는 얼굴은 같다」이고, 그것이 이번 버그다.
 *
 * 2026-08-31 오너 지시로 편집·AI 요청·이미지 교체는 **한 창**이 됐다. 그래서 여기서 갈리는 것은
 * 지우기 하나뿐이고, 나머지 셋은 「열자마자 무엇을 펼치는가」만 다르다.
 */

/** 그림 창이 아는 동작. FigureEditContext 가 보내는 값과 같다. */
export const FIGURE_ACTIONS = ['edit', 'reconvert', 'replace', 'delete'];

export default function figureFaces(action) {
  // 모르는 값은 편집으로 본다 — 창의 기본 얼굴이고, 그때 잠기는 것은 아무것도 없다.
  const deleting = action === 'delete';
  return {
    // 지우기 창인가 — **얼굴을 가르는 유일한 값**이다.
    deleting,
    /**
     * 그림을 **고치는 칸**(미리보기 · 숫자·식)을 내는가. 지우러 온 창에 고칠 칸은 소음이다.
     *
     * 2026-09-01 오너 지시로 원본 사진 칸을 걷었다 — 「이미지 편집 모달에서는 이미지 자체를
     * 수정하는 기능으로 원복시키고, 이미지는 두 개가 아니라 하나만」. 그래서 이름이 종전의
     * `threePane`(3단)이 아니다: 칸 수를 이름에 박아 두면 칸이 늘거나 줄 때마다 거짓이 된다.
     */
    editPanes: !deleting,
    // 미리보기 렌더(POST /figspec/render)를 켜는가.
    renders: !deleting,
    // [저장]을 내는가. **renders 와 반드시 같아야 한다**(저장 잠금이 렌더 결과를 본다).
    saves: !deleting,
    // 「이미지 교체」 칸(원본 사진·지난 버전 고르기)을 내는가. 지우기 창은 이력만 편다.
    picksImage: !deleting,
    // 열자마자 AI 요청 창을 띄우는가 — 그 버튼을 누른 사람은 이미 재요청을 고른 것이다.
    opensAi: action === 'reconvert',
    // 열자마자 고르는 칸을 펼치는가.
    opensPicker: action === 'replace',
  };
}
